/** 
 * Author: Hemant Sharma
 * Type: Config 
 * Objective: To provide messages throughout app 
 * Associated Route/Usage: Global 
*/ 

const messages = {
  common:{
      unavailable: "Service unavailbe, try again",
      clear: "Sure you want to clear the form ?",
      reset: "Sure you want to reset the form ?",
      delete: "Sure you want to delete ?",
      fetchError: "Error fetching data",
      tokenExpired: "Refresh token expired, re-authorize the app",
      badRequest: "Bad Request, try again",
      down: "Sorry! Server is currently down due to maintenance",
      userNotFound: "This user is not registered with AonFlow"
  },
  validations:{
      required: "This is required",
      inputLength: "Input should be minimum 4 chars",
      email: "Please provide valid email",
      validName: "Please provide valid Name",
      validString: "Please provide valid String",
      validNumber: "Please provide valid Number",
      validDate: "Please provide valid Date",
      validBoolean: "Please provide valid Boolean",
      validURL: "Please provide valid URL",
      validDNS: "Please provide valid DNS Name",
      password: "Password must contain a lowercase, uppercase, number and one special char",
      passwordLength: "Password should be minimum 8 chars",
      passwordMatch: "Password and Confirm password should match",
      invalidLogin: "Password or Email entered are incorrect",
      invalidPassword: "Password entered are incorrect",
      acceptTC: "Please accept terms & Conditions",
      pastDate: "Date cannot be older than today",
      pastTime: "Time cannot be older than current",
      alreadyExists: "Already exist",
      oldAndNewPasswordMatch: "New Password can't be same as old password",
      validAddress: "Please enter a valid address",
      validPincode: "Please enter a valid pincode",
      validUserName: "Please enter a valid name",
      validPhoneNumber: "Please enter a valid Phone number",
      validCityName: "Please enter a valid city",
      validStateName: "Please enter a valid state",
      validJson: `Please enter a valid JSON like {"Content-Type": "application/json"}`,
      validFieldName: "Please enter a valid field name",
      validJsonForAdditionalField: `Please enter a valid JSON like { "account number": 574865 }`,
      validCodeVerifier: "Please enter valid code verifier",
      validNumberInput: "Please enter a valid number",
      validFlowNameLength: "Flow name must be between 3 and 128 characters"
  },
  confirm:{
    cancelInvite: "Sure you want to cancel invitation ?",
    updateStatus: "Sure you want to update status ?",
  },
  signup:{
    success: "Signup successful",
    failure: "Signup failed, try again!",
    emailExists: "Email already exists",
    // Adding two more messages as per the requirement
    validation: "Bad Request",
    errorMessage: "Something went wrong"
  },
  oauth2:{
    test:{
      success: "Connection successfull"
    }
  },
  organization:{
    success: "Organization created successfully",
    failure: "Organization creation failed, try again!",
    orgName: "Organization with this name already exist",
    roleChangeRequestSuccess: "Your request raised successfully",
    cancelRoleChangeRequestSuccess: "Your role change request has been canceled successfully",
    leaveOrgSuccess: "You has been leaved the organization successfully",
    editOrgSuccess: "Organization has been updated successfully",
    switchOrgSuccess: "Organization has been switched successfully",
  },
  activation:{
    success: "Activation successful",
    failure: "Activation failed, try again!"
  },
  invitation:{
    success: "Invitation sent successfully",
    failure: "Unable to send invitation, try again!"
  },
  project:{
    success: "Project added successfully",
    failure: "Unable to save, try again!",
    alreadyExists: "This project name already exists. Please use a different name"
  },
  flow:{
    unknown: "An exception has occured from Third party application.",
    step1:{
      updateSuccess: "Flow step1 updated successfully",
      success: "Flow Step1 saved successfully",
      failure: "Unable to save, try again!"
    },
    step2:{
      updateSuccess: "Source & Destination updated successfully",
      success: "Source & Destination saved successfully",
      failure: "Unable to save, try again!"
    },
    step3:{
      updateSuccess: "Flow updated successfully",
      success: "Flow saved successfully",
      failure: "Unable to save, try again!"
    },
    deletion: {
      noFlowExist: "No Flow exist with this id",
      flowAlreadyDeleted: "Flow is already deleted!!"
    },
    addConfig: {
      restApiFields: {
        responseKeyFieldInfo: "This key serves as an identifier in the response, specifying the particular dataset to be retrieved.",
        apiUrlFieldInfo: {
          message: `For data retrieval, you may optionally include a time_field parameter in your API URL.`,
          exampleForApiUrl: `Example: "https://api.example.com/contacts?createdAt=${"$"}{time_field}"`
        }
      }
    }
  },
  flowactiv:{
    failure: "This cannot be activated. Create a connection first with Source and Destination Apps set!",
    dropdownFailure: "Cannot Create Dropdown for fields until both source and destination apps have updated tokens",
    dropdownFailureFieldsLoading: "Fields still Loading...",
    dropdownFail: "Cannot Create Dropdown for fields - Error in Source or Dest response",
    destAppUnavailable: "Cannot Activate as Destination app is not available",
    srcAppUnavailable: "Cannot Activate as Source app is not available",
    bothSrcDestAppUnavailable: "Cannot Activate as Both Source and Destination apps are not available",
    cannotActivate: "Cannot Activate Flow due to error in Response",
    mandatoryFields: "Fields (starting with *) on the target application, please map them to activate the flow",
  },
  user:{
    success: "User added successfully",
    remove: "User removed successfully",
    roleChange: "User role has been changed successfully",
    failure: "Unable to save, try again!"
  },
  save:{
    success: "Saved successfully",
    failure: "Unable to save, try again!"
  },
  update:{
    success: "Updated successfully",
    failure: "Unable to update, try again!"
  },
  delete:{
    success: "Deleted successfully",
    failure: "Unable to delete, try again!"
  },
  cancel:{
    success: "Cancelled successfully",
  },
  upload:{
    success: "File(s) uploaded successfully",
    failure: "Unable to upload, try again!"
  },
  forgotpassword:{
    success: "Password reset link has been successfully sent to the mailid",
    validation: "Bad request",
    errorMessage: "Something went wrong"
  },
  changePassword:{
    success: "Password changed successfully"
  },
  sendVerificationLink:{
    success: "Verification Link has been successfully sent to your registered mailid",
    validation: "Bad request",
    errorMessage: "Something went wrong"
  },
  helperTextList: {
    syncWithError: "No flows exists in this project to sync with.",
    retries: "The number of times the system will re-attempt to post a failed record to its destination."
  },
  flowRunHistory: {
    executionIdLabel: "Search by execution ID",
    search: "Search",
    clear: "Clear",
    executionIdMinLength: "Enter at least 3 characters",
    noMatch: "No match found for this execution ID.",
    searchFailed: "Search could not be completed. Check your connection and try again.",
    resultsTruncatedPrefix: "Showing first ",
    resultsTruncatedSuffix: " matches. Refine your search to narrow results."
  },
  connection: {
    created: "Connection created successfully",
    updated: "Connection updated successfully",
    connectedWithQBO: "Connection to QuickBooks has been connected successfully"
  },
  lookups: {
    target: {
      sourceEntityField: "Source field that has a corresponding field on the destination.",
      lookupEntity: "Entity of the application selected on destination.",
      relatedField: "Destination field that corresponds to the selected source-entity-field.",
      lookupField: "Destination field whose value need to be fetched."
    },
    source: {
      sourceEntityField: "Source field that has a corresponding field on the source.",
      lookupEntity: "Entity of the application selected on source.",
      relatedField: "Source field that corresponds to the selected source-entity-field.",
      lookupField: "Source field whose value need to be fetched."
    }
  }
};

export default messages;